import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultDlpConfig, getDlpTemplateConfig } from './cfg.dlp.default'; //   getTargetProperty,

const cfg = {
  policyType: 6,
  policySubType: 0,
  holderType: 2,
};

export function getDlpGoogleDriveTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const tempConfig = getDefaultDlpConfig();
  merge(tempConfig, cfg);
  return getDlpTemplateConfig(t, tempConfig, accountEmail, [], []);
}
